<input
    type="text"
    name="daterange"
    ngxDaterangepickerMd
    [(ngModel)]="selected"
    (ngModelChange)="onDateChange($event)"
    (clearClicked)="clearDateFilter()"
    [showCustomRangeLabel]="true"
    [alwaysShowCalendars]="true"
    [linkedCalendars]="false"
    [showClearButton]="true"
    [locale]="locale"
    [maxDate]="maxDate"
    [ranges]="ranges"
    [placeholder]="placeholder"
    [keepCalendarOpeningWithRange]="true"
    class="date-picker-input me-2"
    [ngClass]="{ 'date-picker-input-highlight': isDateFilterApplied }"
/>
